/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { List } from 'immutable';

/* Storage */
import { RequestRecord, selectRequestsListByIdsList } from '../storage/requests';

type MultipleRequestSelector = (state?: unknown) => List<ReturnType<typeof RequestRecord>>;

export default function useMultipleRequests(requestIds: List<string>) {
  const requestsSelector = useMemo(
    (): MultipleRequestSelector => selectRequestsListByIdsList(requestIds),
    [requestIds],
  );
  return useSelector(requestsSelector);
}
